import React, {useRef, useState} from "react";
import {
    IonButton,
    IonContent,
    IonHeader, IonInput, IonItem, IonLabel,
    IonPage,
    IonTitle, IonToolbar
} from "@ionic/react";

const ModalUpdatePassword = ({dismiss}: { dismiss: (data?: string | null | undefined, role?: string) => void}) => {

    const [password, setPassword] = useState<string | null | undefined>(undefined);
    const modal = useRef<HTMLIonModalElement>(null);

    return (
        <IonPage ref={modal}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Update Password</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonInput fill="outline" label="New Password:" labelPlacement="floating" onIonChange={(e) => setPassword(e.detail.value)}></IonInput>

                <p style={{textAlign: 'right'}}>
                    <IonButton onClick={() => dismiss(null, 'cancel')} fill="outline">Cancel</IonButton>
                    <IonButton strong={true} onClick={() => dismiss(password, 'confirm')}>
                        Confirm
                    </IonButton>
                </p>
            </IonContent>
        </IonPage>);
};

export default ModalUpdatePassword;